import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-showers-heavy': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M183.9 370.1C176.3 365.7 166.5 368.3 162.1 376.1L98.1 488.1C93.7 495.8 96.4 505.6 104.1 509.9 106.6 511.3 109.3 512 112 512 117.5 512 122.9 509.1 125.9 503.9L189.9 391.9C194.3 384.3 191.6 374.5 183.9 370.1zM279.9 370.1C272.3 365.7 262.5 368.3 258.1 376.1L194.1 488.1C189.7 495.8 192.4 505.6 200.1 509.9 202.6 511.3 205.3 512 208 512 213.5 512 218.9 509.1 221.9 503.9L285.9 391.9C290.3 384.3 287.6 374.5 279.9 370.1zM87.9 370.1C80.3 365.7 70.5 368.3 66.1 376.1L2.1 488.1C-2.3 495.8 0.4 505.6 8.1 509.9 10.6 511.3 13.3 512 16 512 21.5 512 26.9 509.1 29.9 503.9L93.9 391.9C98.3 384.3 95.6 374.5 87.9 370.1zM471.9 370.1C464.3 365.7 454.5 368.3 450.1 376.1L386.1 488.1C381.7 495.8 384.4 505.6 392.1 509.9 394.6 511.3 397.3 512 400 512 405.5 512 410.9 509.1 413.9 503.9L477.9 391.9C482.3 384.3 479.6 374.5 471.9 370.1zM375.9 370.1C368.3 365.7 358.5 368.3 354.1 376.1L290.1 488.1C285.7 495.8 288.4 505.6 296.1 509.9 298.6 511.3 301.3 512 304 512 309.5 512 314.9 509.1 317.9 503.9L381.9 391.9C386.3 384.3 383.6 374.5 375.9 370.1zM416 128C415.4 128 414.9 128.2 414.4 128.2 415.5 123 416 117.6 416 112 416 67.8 380.2 32 336 32 311.4 32 289.7 43.3 275 60.8 256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112 64 119.3 64.8 126.3 66.1 133.2 27.8 145.8 0 181.5 0 224 0 277 43 320 96 320H416C469 320 512 277 512 224S469 128 416 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-showers-heavy.js
// module id = UXze
// module chunks = 144